import React, { useState, useEffect, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminLayoutShell from "../../admin/navigation/AdminLayoutShell";
import {
  partnerSidebarSections,
  PARTNER_PANEL_HOME,
  getPartnerPageTitle,
} from "./partnerNavigation";
import { checkPartnerAccess } from "../../guards/partnerGuard";
import PartnerExpiredPlanModal from "./PartnerExpiredPlanModal";
import PartnerDocumentGuardOverlay from "./PartnerDocumentGuardOverlay";
import "../../admin/navigation/AdminShell.css";
import "./PartnerGuardModal.css";

const PartnerDashboardLayout = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const authUser = authState?.user;
  const token = authUser?.accessToken || authUser?.token || authUser?.refreshToken;
  const userId = authUser?.user?.id || authUser?.userDetails?.id || authUser?.id;

  const [guardState, setGuardState] = useState({
    loading: true,
    allowAccess: true,
    isSubExpired: false,
    isSubPending: false,
    isDocMissing: false,
    subscription: null,
    docStatus: {
      isComplete: true,
      requiredDocs: ["aadhar", "pan"],
      missingDocs: [],
      uploadedDocsMap: {},
      serviceId: "1",
    },
    user: authUser?.user || authUser?.userDetails || null,
    assetUrl: "",
  });

  const evaluateAccess = useCallback(async () => {
    if (!token) return;
    try {
      const result = await checkPartnerAccess({ token, userId });
      const docMissing = !result.docStatus?.isComplete;

      setGuardState({
        loading: false,
        allowAccess: result.allowAccess,
        isSubExpired: result.isSubExpired,
        isSubPending: result.isSubPending,
        isDocMissing: docMissing,
        subscription: result.subscription,
        docStatus: result.docStatus,
        user: result.user || authUser?.user || authUser?.userDetails,
        assetUrl: result.assetUrl,
      });
    } catch (err) {
      console.warn("Partner layout access evaluation warning:", err);
      setGuardState((prev) => ({ ...prev, loading: false }));
    }
  }, [token, userId, authUser]);

  useEffect(() => {
    evaluateAccess();
  }, [evaluateAccess]);

  const shouldBlur = guardState.isSubExpired;

  return (
    <AdminLayoutShell
      sections={partnerSidebarSections}
      homePath={PARTNER_PANEL_HOME}
      logoutRedirect="/login"
      titleGetter={getPartnerPageTitle}
    >
      <div className={`partner-dash-content-wrapper ${shouldBlur ? "partner-dash-blurred" : ""}`}>
        {children ?? <Outlet />}
      </div>

      {/* Expired Plan Pop Modal */}
      {guardState.isSubExpired && (
        <PartnerExpiredPlanModal
          visible={guardState.isSubExpired}
          subscription={guardState.subscription}
          token={token}
          onSuccess={evaluateAccess}
        />
      )}

      {/* Mandatory Documents Upload Guard Overlay */}
      {!guardState.isSubExpired && guardState.isDocMissing && (
        <PartnerDocumentGuardOverlay
          visible={guardState.isDocMissing}
          userData={guardState.user}
          uploadedDocsMap={guardState.docStatus?.uploadedDocsMap || {}}
          assetUrl={guardState.assetUrl}
          token={token}
          userId={userId}
          onRefresh={evaluateAccess}
        />
      )}
    </AdminLayoutShell>
  );
};

export default PartnerDashboardLayout;
